import { Grid } from "@mui/material";
import arrayMutators from "final-form-arrays";
import { Form } from "react-final-form";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import Snack from "../../../components/Snack";
import { transformUtilisateurDataToModel } from "../helpers";
import { renderAdbList } from "../ModifierUtilisateurAdb/helpers";
import UtilisateurAdbForm, {
  UtilisateurFormData,
  validateForm,
} from "../UtilisateurAdbForm";
import { useAjouterUtilisateur } from "./selectors";

function AjouterUtilisateurAdb() {
  const {
    fonctionsPostes,
    getADBRegroupementList,
    adbRegroupementList,
    ajouterUtilisateur,
    adbId,
    adbSelectedDetail,
    utilisateurConnecte,
    fonctionsPostesError,
    utilisateurFetching,
    utilisateurError,
    fonctionsPostesFetching,
    resetPostUtilisateur,
    selectedAdb,
  } = useAjouterUtilisateur();

  const handleSubmit = (values: UtilisateurFormData) => {
    const transformedValues = transformUtilisateurDataToModel(values);
    ajouterUtilisateur(transformedValues);
  };

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/mes-utilisateurs");
  };

  const adbList = renderAdbList(utilisateurConnecte, adbRegroupementList);

  // const handleClose = () => {
  //   emptyErrorMessages();
  // };

  const renderError = (error: any) => {
    return (
      <Snack
        onClose={resetPostUtilisateur}
        open={true}
        variant="error"
        message={error.message}
      />
    );
  };
  const utilisateurBESSE = utilisateurConnecte?.role === "BESSE";

  if (utilisateurConnecte && adbList && adbList.length > 0) {
    return (
      <Layout title={Libelle.pageUtilisateurs.ajouter.titre}>
        <div>
          <h2>
            {Libelle.pageUtilisateurs.ajouter.titre}{" "}
            {Libelle.pageUtilisateurs.ajouter.pourAdb}{" "}
            {adbSelectedDetail && adbSelectedDetail.nom}
          </h2>
          <LoadingBoundary
            loading={utilisateurFetching && fonctionsPostesFetching}
            error={fonctionsPostesError}
          >
            <Form
              validate={(values) => validateForm(values, false)}
              name="ajouterUtilisateurForm"
              onSubmit={handleSubmit}
              mutators={{
                ...arrayMutators,
              }}
            >
              {({
                handleSubmit,
                submitting,
                form: {
                  mutators: { push, pop },
                },
                values,
              }) => (
                <>
                  <UtilisateurAdbForm
                    formValues={values}
                    push={push}
                    pop={pop}
                    selectedAdb={selectedAdb}
                    adbRegroupementList={adbList}
                    onSubmit={handleSubmit}
                    fonctionsPostes={fonctionsPostes}
                    handlePrecedent={handlePrecedent}
                    utilisateurBESSE={utilisateurBESSE}
                    utilisateurConnecte={utilisateurConnecte}
                    isFetching={utilisateurFetching}
                  />
                  <Grid
                    container
                    justifyContent="flex-end"
                    style={{ marginTop: "12px" }}
                  >
                    {utilisateurError && renderError(utilisateurError)}
                  </Grid>
                </>
              )}
            </Form>
          </LoadingBoundary>
        </div>
      </Layout>
    );
  } else {
    return null;
  }
}

// ("ajouterUtilisateurForm");
export default AjouterUtilisateurAdb;
